// extracted by mini-css-extract-plugin
export default {"blockWithBorder":"blockWithBorder_-etA0"};